<template>
    <b-row class="rowbg">
        <b-col md="12">
            <b-card>
                <b-card-title>Sinterklaasshow voor bedrijven</b-card-title>
                <b-card-text>
                    <b-img align="right" class="w-50 cardimage"  v-bind:src="$imagestore2+'images/artikelen/S&P-28-small.jpg'" fluid></b-img>
                    <p>Tijdens onze Sinterklaasshow is afwisseling hét toverwoord. De Pieten nemen de kinderen mee in hun vrolijke avontuur vol zang, dans en gezelligheid. Geen standaard liedjes, maar verrassende muziek waar je vanzelf van gaat meebewegen.</p>
                    <p>Sinterklaas? Die houdt alles goed in de gaten. Met zijn rustige aanwezigheid brengt hij balans in de show. Hij weet over ieder kind wel iets leuks te vertellen en maakt voor iedereen een momentje vrij. Wie wil mag een handje geven of even op schoot – niets moet, alles mag.</p>
                    <p>Juist die afwisseling maakt onze <b>Sinterklaasshow op locatie</b> zo sterk. Kinderen kunnen de spanning kwijt door te zingen en te bewegen, en ouders genieten mee. “Wie heeft er een sterke mama?” – het is een feest voor het hele gezin én het hele bedrijf.</p>
                    <p>Of we nu langs komen op kantoor, in de bedrijfshal of in het restaurant: onze <b>Sinterklaasoptredens voor bedrijven</b> zorgen elk jaar weer voor blije gezichten en warme herinneringen.</p>
                </b-card-text>
            </b-card>
        </b-col>
        <b-col md="12">
            <b-card>
                <b-card-title>Het Online Grote Boek<span class="d-none d-md-inline"> – handig en overzichtelijk</span></b-card-title>
                <b-card-text>
                    <b-img align="left" class="w-50 cardimage"  v-bind:src="$imagestore2+'images/artikelen/S&P-16-small.jpg'" fluid alt="Fluid image"></b-img>
<p>
    Voor elke <strong>Sinterklaasshow op locatie</strong> maken wij een unieke webpagina: het toegangspunt tot <strong>het Online Grote Boek</strong>. Hier kunnen ouders zich aanmelden en eenvoudig de informatie over hun kinderen invullen – zoals naam, leeftijd, hobby’s of wat ze op hun verlanglijstje hebben staan.
</p>
<p>
    Alle gegevens komen direct op één centrale plek terecht, zodat Sinterklaas goed voorbereid is en alles netjes klopt. Geen losse lijstjes meer met namen of leeftijden: <strong>het Online Grote Boek</strong> is altijd up-to-date.
</p>
<p>
    Ook als organisator heeft u toegang tot het systeem. Zo houden we het overzicht samen – veilig, makkelijk en volledig afgestemd op jullie show.
</p>
<p>
    Een slimme extra service die uw <strong>Sinterklaasoptreden voor bedrijven</strong> nóg soepeler laat verlopen.
</p>                </b-card-text>
            </b-card>
        </b-col>
        <b-col md="12">
            <b-card>
                <b-card-title> Repertoire van Piet</b-card-title>
                <b-card-text>
<p>
    Sinds dag één ontwikkelen wij ons eigen repertoire met vrolijke en herkenbare <strong>Sinterklaasliedjes</strong> voor kinderen. Van rustige verhaaltjes en theatrale momenten tot energieke spellen over paarden, pepernoten en stoomboten – onze <strong>Pietenmuziek</strong> is altijd afgestemd op de beleving van het kind.
</p>
<p>
    We maken ook <strong>originele liedjes</strong> over thema’s die dichtbij staan: tandenpoetsen, buitenspelen of knutselen. Vaak met een vrolijke videoclip erbij, zodat de voorpret thuis al kan beginnen!
</p>
<p>
    Onze muziek is gemaakt om samen te beleven: meezingen, uitbeelden, dansen – de kinderen doen écht mee. Zo is Piet er voor de hele groep, terwijl <strong>Sinterklaas</strong> aandacht geeft aan het individuele kind.
</p>
<p>
    Onze eigen nummers zijn een belangrijk onderdeel van elke <strong>Sinterklaasshow</strong>, en maken het verschil tussen een standaard optreden en een echte beleving.
</p>
<p>
    Enkele van onze eigen liedjes zijn:
</p>
                       <silent-box class="galleryitems" :gallery="repertoire"></silent-box>
                </b-card-text>
            </b-card>
        </b-col>
        <b-col md="12">
            <b-card>
                <b-card-title>Sfeer, muziek en ondersteuning</b-card-title>
                <b-card-text>
                    <b-img align="left" class="w-50 cardimage"  v-bind:src="$imagestore1+'/website%202018/Ridder-en-de-Prins---Techniek.jpg'" fluid alt="Fluid image"></b-img>
  <p>
    De spanning stijgt… is dat een staf of een veer in de verte? Ondertussen speelt op de achtergrond al de sfeermuziek – verzorgd door onze <b>techniek</b>. Er wordt nog snel even afgestemd tussen Piet in de auto en de organisatie op locatie.
</p>
<p>
    Bij aankomst krijgen <b>Piet en Sinterklaas</b> direct een microfoon in handen. Zo kunnen ze zonder gedoe de zaal in en meteen beginnen. Onze technici zorgen voor een soepel verloop van de show: heldere stemmen, goede timing en natuurlijk de juiste muziek op het juiste moment.
</p>
<p>
    We kunnen de volledige <strong>geluidsverzorging voor de Sinterklaasshow</strong> meenemen, inclusief installatie en bediening. Maar werken net zo graag samen met de techniek van de locatie, als die al aanwezig is.
</p>
<p>
    Onze techniek ondersteunt niet alleen de sfeer, maar het hele feest – van aankomst tot applaus.
</p>                </b-card-text>
            </b-card>
        </b-col>
        <b-col md="12">
            <b-card>
                <b-card-title>Cadeauservice</b-card-title>
                <b-card-text>
                    <b-img align="right" class="w-50 cardimage"  v-bind:src="$imagestore1+'/website%202018/Ridder-en-de-Prins---Cadeauservice.jpg'" fluid alt="Fluid image"></b-img>
                    Eind november geven wij heel wat gretige kinderhanden een cadeau. Aan het eind van de show komen die tevoorschijn en daarna verlaten we met gezang de zaal. Onze cadeauservice ontzorgt u volledig in dit proces. De ouders vullen digitaal het Grote Boek in en kiezen gelijk per kind een cadeau. Van te voren kiest u een prijscategorie, €15,- of €20,- Wij maken een voorselectie van 24 tot 30 degelijke en hoogwaardige cadeaus waarbij er zeker voor iedereen iets leuks te kiezen is. Ook nemen wij reserve cadeaus mee voor als er onverwachts nog een broertje of zusje meekomt. Zo staat niemand met lege handen.                </b-card-text>
            </b-card>
        </b-col>
        <b-col md="12">
            <b-card>
                <b-card-title>Reserveer direct</b-card-title>
                <b-card-text>
                    <b-link to="/contact">
                        <b-img align="right" class="w-50 cardimage"  v-bind:src="$imagestore1+'/website%202018/Ridder-en-de-Prins---Piet-schrijft-in-het-Grote-boek.jpg'" fluid alt="Fluid image"></b-img>
                    </b-link>
                    <p>
                    Laat ons weten wat u zoekt en leg een prachtige Sinterklaasshow vast.
                    </p>
                    <b-link to="/contact">
                        <b-img align="left" v-bind:src="$imagestore1+'/logo/boeknu.png'" fluid alt="Fluid image"></b-img>
                    </b-link>
                </b-card-text>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        name: 'Sinterklaasshow',
        data: function() {
            return {
                repertoire: [{
                        src: 'https://www.youtube.com/watch?v=nvkMp7pF-4U'
                    },
                    {
                        src: 'https://www.youtube.com/watch?v=7IdAfQsrcdw'
                    },
                    {
                        src: 'https://www.youtube.com/watch?v=hIuchunSDSs'
                    }
                ]
            }
        }
    }
</script>

<style>

</style>

